import React from 'react';
import Slider from 'react-slick';
import { FaStar } from 'react-icons/fa';

// Import images from assets
import barchi from '../assets/img/barchi.jpeg';
import gulmira from '../assets/img/gulmira.jpeg';
import samishka from '../assets/img/samiksha.jpeg';

const testimonialsData = [
  {
    name: 'Samiksha',
    position: 'Data Engineer',
    photo: samishka,
    rating: 5,
    linkedin: 'https://www.linkedin.com/in/samiksha-patil/',
    feedback:
      'I really loved the insights and that Recep provided that will definitely improve my resume. He noticed small details in my resume and made sure they are up to the mark. He also helped with with useful resources to refer. It was great talking with him! Thank you for helping me out!',
  },
  {
    name: 'Gulmira',
    position: 'QA Tester',
    photo: gulmira,
    rating: 5,
    linkedin: 'https://www.linkedin.com/in/gulmira-sidagulova-398436a4/',
    feedback:
      'I am very grateful for the interview with Recep. He provided more information and was more helpful than I expected. We went through my LinkedIn profile, and he gave me valuable advice on how to improve my professional image and highlight my skills. I’m sure that after the interview with him, you will be amazed at how you can improve your professional profile on LinkedIn. Reсep also helped me believe in myself and start applying for the jobs I wanted. Thank you so much and good luck with your work!',
  },
  {
    name: 'Barchynai',
    position: 'Frontend Developer',
    photo: barchi,
    rating: 5,
    linkedin: 'https://www.linkedin.com/in/barchynai-koch/',
    feedback:
      "Session with Recep was very helpful and inspiring. I'm very thankful for support and I hope to work with him on my further career roadmap !",
  },
];

export default function TestimonialsCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <div className='bg-gray-100 py-12'>
      <div className='flex justify-center items-center flex-col mb-8'>
        <h2
          className='text-4xl md:text-5xl font-extrabold text-center 
                 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 
                 bg-clip-text text-transparent tracking-wider 
                 drop-shadow-lg uppercase relative inline-block'
        >
          Our Testimonials
          <span
            className='absolute left-1/2 -bottom-2 w-20 h-1 bg-pink-500 
                     rounded-full -translate-x-1/2 animate-pulse'
          ></span>
        </h2>
      </div>

      <div className='max-w-3xl mx-auto'>
        <Slider {...settings}>
          {testimonialsData.map((t, index) => (
            <div key={index}>
              <div className='bg-white p-6 rounded-xl shadow-lg flex flex-col items-center text-center space-y-4'>
                <img
                  src={t.photo}
                  alt={t.name}
                  className='w-28 h-28 md:w-32 md:h-32 rounded-full object-cover cursor-pointer border-4 border-blue-400 shadow-lg transform transition duration-300 hover:scale-105'
                  onClick={() => window.open(t.linkedin, '_blank')}
                />

                {/* Name with gradient */}
                <h3 className='font-bold text-xl bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 bg-clip-text text-transparent drop-shadow-md'>
                  {t.name}
                </h3>

                {/* Position with colored underline */}
                <p className='text-sm font-medium text-indigo-600 relative before:absolute before:bottom-0 before:left-1/4 before:w-1/2 before:h-0.5 before:bg-pink-500 before:rounded'>
                  {t.position}
                </p>

                {/* Star rating */}
                <div className='flex justify-center'>
                  {Array.from({ length: 5 }, (_, i) => (
                    <FaStar
                      key={i}
                      className={`h-5 w-5 ${
                        i < t.rating ? 'text-yellow-400' : 'text-gray-300'
                      }`}
                    />
                  ))}
                </div>

                {/* Feedback */}
                <p className='text-gray-700'>{t.feedback}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
